module.exports = __webpack_public_path__ + "img/Realisme_Tanker_i_tida3.e1bea193.jpg";